import {useEffect} from 'react';

export default function useAutoScroll(speed: number) {
  useEffect(() => {
    if (speed === 0) return;

    const scrollDistance = speed * 2;

    let id: number;
    const step = () => {
      id = requestAnimationFrame(step);
      window.scrollBy(0, scrollDistance);
    };

    id = requestAnimationFrame(step);

    return () => {
      id && cancelAnimationFrame(id);
    };
  }, [speed]);
}
